import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const kategoriWebOptions = ["Semua", "Peduli Sumatera", "Peduli Sudan", "Peduli Palestina", "Peduli Lansia", "Peduli Yatim"];

const News = () => {
  const [newsList, setNewsList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState<any>(null);
  const [kategoriWeb, setKategoriWeb] = useState("Semua");

  const fetchNews = async () => {
    setLoading(true);
    try {
      const params: any = {
        page,
        per_page: 5,
      };

      if (kategoriWeb !== "Semua") {
        params.kategori_web = kategoriWeb;
      }

      const res = await axios.get(`${API_BASE}/api/berita`, { params });

      setNewsList(res.data.data);
      setMeta(res.data.meta);
    } catch (err) {
      console.error("Gagal ambil berita:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, [page, kategoriWeb]);

  const stripHtml = (html: string, max = 80) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || "";
    return text.length > max ? text.slice(0, max) + "..." : text;
  };

  return (
    <div className="mt-6">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <h2 className="text-2xl font-bold text-orange-600">Manajemen Berita</h2>

        <div className="flex gap-2 items-center">
          <select
            value={kategoriWeb}
            onChange={(e) => {
              setPage(1);
              setKategoriWeb(e.target.value);
            }}
            className="border border-orange-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400">
            {kategoriWebOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          <Link to="/dashboard/news/tambah" className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm">
            + Tambah Berita
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full text-sm">
          <thead className="bg-orange-500 text-white">
            <tr>
              <th className="p-3 text-left">Judul</th>
              <th className="p-3 text-left">Gambar</th>
              <th className="p-3 text-left">Kategori</th>
              <th className="p-3 text-left">Web Peduli</th>

              <th className="p-3 text-left">Tanggal Dibuat</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : newsList.length === 0 ? (
              <tr>
                <td colSpan={7} className="p-4 text-center text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              newsList.map((item) => (
                <tr key={item.id} className="border-t hover:bg-orange-50 transition">
                  <td className="p-3 font-medium text-gray-800">{item.judul.length > 10 ? item.judul.substring(0, 20) + "..." : item.judul}</td>

                  <td className="p-3">{item.gambar ? <img src={item.gambar} alt={item.judul} className="w-24 h-16 object-cover rounded-md border" /> : "-"}</td>

                  <td className="p-3">{item.kategori}</td>
                  <td className="p-3">
                    <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs">{item.kategori_web}</span>
                  </td>

                  <td className="p-3">{new Date(item.created_at).toLocaleDateString()}</td>

                  <td className="p-3">
                    <Link to={`/dashboard/news-detail/${item.id}`} className="text-orange-600 hover:underline">
                      Detail
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {meta && (
        <div className="flex justify-between items-center mt-4 text-sm">
          <span className="text-gray-600">
            Page {meta.current_page} dari {meta.last_page} | Total {meta.total}
          </span>

          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Prev
            </button>

            <button disabled={page === meta.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
